import { DETAILED_DATA_GRID_CLASS_NAME } from '../../constants/data-grid';
import FingoMuiDataGrid, { detailedDataGrid } from '../../fingo/components/MuiDataGrid';

const MuiDataGrid = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiDataGrid.styleOverrides.root({ theme }),
      [`&.${DETAILED_DATA_GRID_CLASS_NAME}`]: detailedDataGrid({
        theme,
        selectedRowColor: theme.palette.secondary.A200,
        selectedCheckboxColor: theme.palette.secondary.main,
      }),
    }),
  },
};

export default MuiDataGrid;
